import * as React from 'react';
import { useIntersectionObserver } from '@grandvisionhq/lib-utils-react';
import { ProductImage } from '../../../ProductImage/ProductImage.js';

const MobileProductImage = ({ handleInView , index , image , activeIndex , handleImageInteraction , imageParams ,  })=>{
    const { ref  } = useIntersectionObserver({
        threshold: 0.8,
        onChange: (inView)=>handleInView(inView, index)
    });
    return /*#__PURE__*/ React.createElement("div", {
        key: image.label,
        ref: ref,
        id: `mobile__image-scroll-item-${index}`,
        className: `product-image-gallery-mobile__image-scroller-item`
    }, /*#__PURE__*/ React.createElement(ProductImage, {
        isOutOfView: index !== activeIndex,
        showImage: index >= activeIndex - 1 && index <= activeIndex + 1,
        altText: image.altText,
        imageUrl: image.url,
        imageParams: imageParams,
        onClick: ()=>handleImageInteraction(index)
    }));
};

export { MobileProductImage };
//# sourceMappingURL=MobileProductImage.js.map
